import { Instagram, Facebook, Youtube, Music2 } from "lucide-react";
import { SITE } from "../data/site";

// Custom TikTok icon (lucide doesn't ship one)
const TikTokIcon = ({ size = 16 }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="currentColor"
    aria-hidden="true"
  >
    <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.49a8.16 8.16 0 0 0 4.77 1.52V6.69h-1.84z" />
  </svg>
);

const ICONS = {
  instagram: Instagram,
  facebook: Facebook,
  youtube: Youtube,
  tiktok: TikTokIcon,
  spotify: Music2,
};

export default function Socials({ variant = "row", className = "" }) {
  if (variant === "row") {
    return (
      <div data-testid="socials-row" className={`flex flex-wrap items-center gap-3 ${className}`}>
        {SITE.social.map((s, i) => {
          const Icon = ICONS[s.icon] || Music2;
          return (
            <a
              key={s.href}
              data-testid={`social-${s.icon}-${i}`}
              href={s.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${s.label} — ${s.handle}`}
              title={`${s.label} · ${s.handle}`}
              className="group h-11 w-11 border border-white/10 flex items-center justify-center hover:border-[#991B1B] hover:bg-[#991B1B]/10 transition-all"
            >
              <Icon size={16} />
            </a>
          );
        })}
      </div>
    );
  }

  // column / list variant
  return (
    <div data-testid="socials-list" className={`flex flex-col gap-3 ${className}`}>
      {SITE.social.map((s, i) => {
        const Icon = ICONS[s.icon] || Music2;
        return (
          <a
            key={s.href}
            data-testid={`social-list-${s.icon}-${i}`}
            href={s.href}
            target="_blank"
            rel="noopener noreferrer"
            className="cine-link flex items-center gap-3 text-[#A0A0A8] text-sm"
          >
            <span className="text-[#991B1B] flex items-center justify-center w-4">
              <Icon size={14} />
            </span>
            <span className="font-medium text-white">{s.label}</span>
            <span className="text-[#6B6B72]">· {s.handle}</span>
          </a>
        );
      })}
    </div>
  );
}
